import { Provider } from '@angular/core';
import { ApplicationService, AuthenticationService, ErrorService } from '@pit/core';
import { PinItTrackFrontendApplicationService } from '../services/implementations/pin.it.track.frontend.application.service';
import { PinItTrackFrontendAuthenticationService } from '../services/implementations/pin.it.track.frontend.authentication.service';
import { PinItTrackFrontendErrorService } from '../services/implementations/pin.it.track.frontend.error.service';

export const pinItTrackFrontendCoreServicesProviders: Provider[] = [

    {
        provide: ApplicationService,
        useClass: PinItTrackFrontendApplicationService
    },
    {
        provide: AuthenticationService,
        useClass: PinItTrackFrontendAuthenticationService
    },
    {
        provide: ErrorService,
        useClass: PinItTrackFrontendErrorService
    }

];
